import { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import ModalNewPeriod from './ModalNewPeriod'

let date = new Date()
const currentYear = date.getFullYear()
const initialYear = 2023
const years = Array(currentYear - initialYear + 1)
    .fill(1)
    .reduce((carry, _, index) => {
        carry.push(initialYear + index)
        return carry
    }, [])
const initialState = {
    nombre: '',
    gestion: currentYear,
    periodo: '',
}

const Seeker = ({ facultyNames, getFacultiesBySeeker, setFilters, createNewManagement }) => {
    const [showModal, setShowModal] = useState(false)
    const [paramsSeeker, setParamsSeeker] = useState(initialState)

    const handleSearch = () => {
        getFacultiesBySeeker()
    }

    const handleOnChange = (e) => {
        setFilters((lastValue) => ({ ...lastValue, [e.target.name]: e.target.value }))
        setParamsSeeker({
            ...paramsSeeker,
            [e.target.name]: e.target.value,
        })
    }

    const handleClean = () => {
        getFacultiesBySeeker(1, { nombre: '', periodo: '' })
        setParamsSeeker((lastValue) => ({ ...lastValue, nombre: '', periodo: '' }))
        setFilters((lastValue) => ({ ...lastValue, nombre: '', periodo: '' }))
    }

    return (
        <div className='seeker mt-3'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                <div className='seeker__inputs'>
                    <div className='seeker__input'>
                        <label>Gestión</label>
                        <Form.Select name='gestion' value={paramsSeeker.gestion} onChange={handleOnChange}>
                            {years.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                    <div className='seeker__input'>
                        <label>Facultad</label>
                        <Form.Select name='nombre' value={paramsSeeker.nombre} onChange={handleOnChange}>
                            <option value=''>Seleccione una facultad</option>
                            {facultyNames &&
                                facultyNames.length > 0 &&
                                facultyNames.map((fac) => {
                                    return (
                                        <option key={`${fac.codigo}`} value={fac.nombre}>
                                            {fac.nombre}
                                        </option>
                                    )
                                })}
                        </Form.Select>
                    </div>
                    <div className='seeker__input'>
                        <label>Periodo</label>
                        <Form.Select name='periodo' value={paramsSeeker.periodo} onChange={handleOnChange}>
                            <option value=''>Seleccione un periodo</option>
                            <option value='0'>0 - Anual</option>
                            <option value='1'>1 - Primer Semestre</option>
                            <option value='2'>2 - Segundo Semestre</option>
                            <option value='3'>3 - Verano</option>
                            <option value='4'>4 - Invierno</option>
                        </Form.Select>
                    </div>
                </div>
                <div>
                    <Button variant='primary' className='me-3' onClick={() => setShowModal(true)}>
                        Nuevo Periodo
                    </Button>
                    <Button variant='success' onClick={() => createNewManagement()}>
                        Nueva Gestión
                    </Button>
                </div>
            </div>
            <div className='seeker__btns'>
                <Button variant='danger' onClick={handleClean}>
                    Limpiar Búsqueda
                </Button>
                <Button variant='blue' onClick={handleSearch}>
                    Buscar
                </Button>
            </div>
            <ModalNewPeriod
                show={showModal}
                onHide={() => setShowModal(false)}
                onAccept={async (periodos, gestion) => {
                    const success = await createNewManagement(periodos, gestion)
                    success && setShowModal(false)
                    return success
                }}
            />
        </div>
    )
}

export default Seeker
